'use strict';

var FirebaseArray = require('./FirebaseArray');
var KayleeBase = require('./KayleeBase');
var KayleeCache = require('./KayleeCache');
var KayleeUtil = require('./KayleeUtil');
//var log = require('../log/Log').channel('KayleeEquipmentTypes');

var equipmentTypeTypes = [
    'amplifier',
    'audioDsp',
    'avReceiver',
    'camera',
    'display',
    'gpio',
    'lightingController',
    'tuner',
    'usbSwitcher',
    'videoCodec',
    'videoSwitcher',
];

var KayleeEquipmentTypes = {
    equipmentTypeTypes: equipmentTypeTypes,
    fromJson: fromJson,
    getEquipmentTypes: getEquipmentTypes,
};

function fromJson(data) {
    var reqProps = [];
    return FirebaseArray.$fromJson(data, 'EquipmentTypes', reqProps, reqProps,
        function(data) { return getEquipmentTypes(); });
}

function getEquipmentTypes() {
    var key = 'EquipmentTypes';
    var equipmentTypes = KayleeCache.get(key);

    if (equipmentTypes === null) {
        equipmentTypes = new EquipmentTypes();
        KayleeCache.put(key, equipmentTypes);
    }

    return equipmentTypes;
}

function EquipmentTypes() {
    var srcRef = KayleeBase.app.database().ref('equipmentTypes');
    this.$nodeType = 'equipmentTypes';
    FirebaseArray.call(this, srcRef);
    KayleeUtil.bindPrototypeMethods(EquipmentTypes.prototype, this, this.$items);
    this.$items.$self = this;
    return this.$items;
}

EquipmentTypes.prototype = Object.create(FirebaseArray.prototype);
EquipmentTypes.prototype.constructor = EquipmentTypes;

EquipmentTypes.prototype.$toJson = function()  {
    return FirebaseArray.prototype.$toJson.call(this, [], {});
};

EquipmentTypes.prototype.$getByTypeName = function(typeName) {
    for (var i = 0; i < this.$items.length; i++) {
        if (this.$items[i].type === typeName) return this.$items[i];
    }

    return null;
};

EquipmentTypes.prototype.toString = function() {
    return '[Equipment Types]';
};

module.exports = KayleeEquipmentTypes;
